<template>
  <div
    class="rs-list-group-item"
    :class="{
      active: active,
      disabled: disabled,
      inline: inline,
      grid: grid,
      clickable: clickable,
    }"
    @click="$emit('click')"
  >
    <slot />

    <span
      v-if="icon"
      class="float-right"
    >
      <RsIcon icon="angle-right" />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsListGroupItem',

  props: {
    /**
      * The list item text.
      */
    title: String,
    /**
      * The target URL.
      */
    href: String,
    /**
      * Places the component in the active state with active styling.
      */
    active: {
      type: Boolean,
      default: false,
    },
    /**
        * Disables the component's functionality and places it in a disabled state.
        */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Enable inline display
     */
    inline: {
      type: Boolean,
      default: false,
    },
    /**
     * Enable Grid view
     */
    grid: {
      type: Boolean,
      default: false,
    },
    /**
     * Show Arrow Right Icon
     */
    icon: {
      type: Boolean,
      default: false,
    },
    /**
     * Enable item clickable
     */
    clickable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-list-group-item{
  position: relative;
  display: block;
  padding: 1.5rem;
  margin-bottom: -1px;
  background-color: $white;
  border: 1px solid $extra-light-gray;

  &.active{
    background-color: $primary-color;
    color: $white;
  }
  &.disabled{
    color: $dark-gray;
  }
  &.inline{
    display: flex;
  }
  &.grid {
    display: grid;
    grid-template-columns: 200px auto 15px;
  }
  &.clickable {
    cursor: pointer;
  }
  p {
    margin: 0;
  }
}
</style>
